var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button-back",on:{"click":function($event){_vm.hasHistory() ? _vm.$router.go(-1) : _vm.$router.push('/')}}},[_c('ArrowLeftIcon',{staticClass:"button-back__icon",attrs:{"width":"15","fill":"#0a294a"}}),_c('span',[_vm._v("Return")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }